import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { ContractStatusFilter as ContractStatusFilterEnum } from '../client-insurer-index/client-insurer-index-types';
import {
  ContractStatusFilterProps,
  StatusFilterLabelText,
} from './filter-types';

export const ContractStatusFilter = ({
  control,
}: ContractStatusFilterProps): JSX.Element => {
  const options = [
    { value: ContractStatusFilterEnum.All, label: 'All' },
    { value: ContractStatusFilterEnum.Active, label: 'Active' },
    { value: ContractStatusFilterEnum.NotActive, label: 'Not Active' },
  ];

  return (
    <Controller
      control={control}
      name="contractStatus"
      render={({ field: { onChange, value } }): JSX.Element => {
        const selectedOption =
          options.find(option => option.value === value) ?? options[0];
        return (
          <Autocomplete
            id="contract-status-select"
            value={selectedOption}
            options={[...options]}
            disableClearable
            size="small"
            sx={{ minWidth: 230, maxWidth: 230 }}
            onChange={(_, newValue): void => onChange(newValue.value)}
            getOptionLabel={(option): string => option.label}
            isOptionEqualToValue={(option, val): boolean =>
              option.value === val.value
            }
            renderInput={(params): JSX.Element => (
              <HHTextField
                {...params}
                hhVariant="variant-bypass"
                variant="standard"
                label={StatusFilterLabelText.CONTRACT_STATUS}
              />
            )}
          />
        );
      }}
    />
  );
};
